export default __webpack_public_path__ + "static/media/logo-thebar@3x.225994ab.svg";